import * as React from "react";
import * as cn from "classnames/bind";
import * as styles from "./layout-picker.css";
import { SvgCalendarLayout } from "ui/constants";
import { useResources } from "contexts/resource-context";
import { CalendarType } from "svg/constants";

interface LayoutPickerProps {
    onClick: (layout: SvgCalendarLayout) => void;
    layouts: Array<SvgCalendarLayout>;
    selected: SvgCalendarLayout | null;
    calendarType: CalendarType;
}

const LayoutPicker: React.FC<LayoutPickerProps> = ({
    onClick,
    layouts,
    selected,
    calendarType,
}) => {
    const cx = cn.bind(styles);

    const resource = useResources();

    const iconPickerCs = () =>
        cx({
            iconPicker: true,
            iconPickerSmall: false,
            iconPickerWithHeader: false,
        });

    const iconPickerLiCn = () =>
        cx({
            iconPickerLi: true,
            iconPickerLiSmall: false,
        });

    const iconPickerItemCn = (isSelected: boolean) =>
        cx({
            iconPickerItem: true,
            iconPickerItemSmall: false,
            iconPickerItemImageAuto: true,
            iconPickerItemSelected: isSelected,
        });

    const iconPickerContent = () =>
        cx({
            content: true,
        });

    const iconPickerTextWrapper = () =>
        cx({
            iconPickerTextWrapper: true,
        });

    const iconPickerTitle = () =>
        cx({
            iconPickerTitle: true,
        });

    const iconPickerDescription = () =>
        cx({
            iconPickerDescription: true,
        });

    const iconPickerRoomFor = () =>
        cx({
            iconPickerRoomFor: true,
        });

    return (
        <ul className={iconPickerCs()}>
            {layouts.map((layout) => (
                <li
                    className={iconPickerLiCn()}
                    key={layout.id}
                    onClick={() => {
                        onClick(layout);
                    }}>
                    <div
                        className={iconPickerItemCn(
                            selected !== null && selected.id == layout.id,
                        )}>
                        <div className={iconPickerContent()}>
                            <div
                                dangerouslySetInnerHTML={{
                                    __html: layout.endpoints.thumbnail || "",
                                }}></div>
                            <div>
                                <p className={iconPickerTextWrapper()}>
                                    <span className={iconPickerTitle()}>
                                        {layout.title ? layout.title : ""}
                                    </span>
                                    <br />
                                    <span className={iconPickerDescription()}>
                                        {layout.description}
                                    </span>
                                </p>
                                <p className={iconPickerRoomFor()}>
                                    <span>{resource.Layout_RoomFor}</span>
                                    <span>
                                        {layout.maxWeekModules}{" "}
                                        {calendarType === CalendarType.Notebook
                                            ? resource.Notebook_WeekModules.toLocaleLowerCase()
                                            : resource.NavControls_WeekModules.toLocaleLowerCase()}
                                    </span>
                                    <span>
                                        {layout.maxDayModules}{" "}
                                        {calendarType === CalendarType.Notebook
                                            ? resource.Notebook_DayModules.toLocaleLowerCase()
                                            : resource.NavControls_DayModules.toLocaleLowerCase()}
                                    </span>
                                </p>
                            </div>
                        </div>
                    </div>
                </li>
            ))}
        </ul>
    );
};

export default LayoutPicker;
